import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../../../core/animations';

/**Local files */
import { displayValues, assignPro, spekwo } from '../../../../../../../utils/index';

/** Service file */
import { AssignProService } from '../../../../../../assignPro/assignPro.service';
import { SideNavService } from '../../../../sidenav.service';

@Component({
    selector: 'user-info',
    templateUrl: './userInfo.component.html',
    styleUrls: ['./userInfo.component.scss'],
    animations: fuseAnimations
})

export class UserInfoComponent {

    displayValues = displayValues;
    assignPro = assignPro;
    spekwoValues = spekwo;

    displayedColumns = ['name', 'detail-button'];

    proUsers: UserData[] = [];

    dataSource: MatTableDataSource<UserData>;
    @ViewChild(MatPaginator) userPaginator: MatPaginator;
    @ViewChild(MatSort) userSort: MatSort;

    proUsersSubscription: Subscription;
    onProInfoFilteredSubscription: Subscription;
    onProInfoChangedSubscription: Subscription;

    filesList = [];
    selected: any;
    isLoading: boolean = false;

    constructor(
        /** Service file */
        public assignProService: AssignProService,
        public sideNavService: SideNavService
    ) {
        this.sideNavService.onProUserInfoTabSelected.subscribe(selected => {
            this.selected = selected.userId;
        });
    }

    ngOnInit() {

        this.isLoading = true;


        /**
    * Get files documents 
    * */

        this.onProInfoChangedSubscription =
            this.sideNavService.onProInfoChanged.subscribe(files => {
                this.filesList = files.message;
            }, () => {
            })

        /**     
        * Get all pro users  
        * */
        this.proUsersSubscription =
            this.assignProService.onAllProUsers.subscribe(response => {

                this.isLoading = true;

                if (!response.loading) {

                    this.proUsers = response.users;
                    this.dataSource = new MatTableDataSource(this.proUsers);
                    this.dataSource.paginator = this.userPaginator;
                    this.dataSource.sort = this.userSort;
                    this.isLoading = false;

                    /**
                * Initially points first userId
                */
                    if (this.proUsers.length > 0) {

                        var userId = response.users[0].userId;
                        this.sideNavService.onProUserInfoTabSelected.next(response.users[0]);
                        this.sideNavService.onProInfoSelected.next([this.filesList[userId], userId, response.users[0].firstName]);
                    }
                    this.isLoading = false;
                }
            }, () => {
                this.isLoading = false;
            })

        /** Filter pro people */

        this.onProInfoFilteredSubscription =
            this.sideNavService.onProInfoFiltered.subscribe(filter => {

                filter = filter.trim(); // Remove whitespace
                filter = filter.toLowerCase(); // MatTableDataSource defaults to lowercase matches
                this.dataSource.filter = filter;
            })

        this.isLoading = true;
    }

    ngOnDestroy() {
        this.onProInfoChangedSubscription.unsubscribe();
        this.proUsersSubscription.unsubscribe();
        this.onProInfoFilteredSubscription.unsubscribe();
    }

    setDefaultPic(event) {
        event.target.src = this.spekwoValues.defaultImg;
    }

    /** Based on row select- Change sidenav */
    onSelect(selected) {
        var userName = selected.firstName;
        this.sideNavService.onProUserInfoTabSelected.next(selected);
        this.sideNavService.onProInfoSelected.next([this.filesList[selected.userId], selected.userId, userName]);
    }

}
export interface UserData {
    profile: string;
    email: string;
    password: string,

}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/list/userInfo.component.ts